<template>
  <d-card :class="['card-small d-inline-flex', { 'show': show }]" :style="{ 'top': `${up}px`, 'left': `${left}px` }">
    <d-card-body class="px-2 py-0">
      <d-form-row>
        <d-col class="form-group">
          <label>Tamanho do texto</label>
          <d-select v-model="cell.question.size_id" @change="recalcQuestionLimit">
            <option value="">Selecione um tamanho</option>
            <option
              :value="option.id"
              v-for="option in optionsSizes"
              :key="option.id"
            >{{ option.name }}</option>
          </d-select>
        </d-col>
        <d-col class="form-group">
          <label>Tamanho da fonte</label>
          <d-select v-model="cell.settings.font_size">
            <option value="">Selecione o tamanho da fonte</option>
            <option
              :value="n+7"
              v-for="n in 5"
              :key="n"
            >{{ n + 7 }}px</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col class="form-group" v-if="questionsAvailable">
          <label>Perguntas cadastradas <small v-if="question" class="link" @click="editQuestion">Editar pergunta</small></label>
          <d-select v-model="question" @change="selectQuestion">
            <option value="">Selecione uma pergunta</option>
            <option
              :value="option"
              v-for="(option, key) in questionsAvailable"
              :key="key"
            >{{ option.question }}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col class="form-group">
          <label>Pergunta <small v-if="cell.answer.answer">( Resposta: {{ cell.answer.answer }} )</small></label>
          <textarea
            :class="['form-control', { 'bold': cell.settings.bold }]"
            :style="{ 'fontSize': `${cell.settings.font_size}px` }"
            v-model="cell.question.question"
            @keydown="limitQuestion"
          ></textarea>
          <!-- <d-checkbox @change="toggleSetting($event,'bold')" v-model="cell.settings.bold">Bold</d-checkbox> -->
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <d-button type="button" @click="save()">Salvar</d-button>
        </d-col>
      </d-form-row>
    </d-card-body>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import PuzzleService from '_services/rest/modules/puzzle';
import {
  CELL,
  CELL_SIZE,
  _PUZZLE_QUESTION_OPTION_,
  _PUZZLE_CLOSE_ALL_MODAL_,
  _PUZZLE_SET_QUESTION_,
  _PUZZLE_EDIT_QUESTION_OPTION_,
  _PUZZLE_UPDATE_QUESTION_OPTION_,
} from '../PuzzleModel';

export default {
  name: 'puzzle-option-question-modal',
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        return puzzle;
      }
      return false;
    },
    optionsSizes() {
      const { questionSizes } = this.$store.state.puzzle;
      if (questionSizes) {
        return questionSizes;
      }
      return [{ id: null, name: null }];
    },
  },
  data() {
    return {
      up: 0,
      cell: cloneDeep(CELL),
      left: 0,
      show: false,
      question: null,
      questionsAvailable: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getQuestionSizes',
    ]),
    save() {
      this.cell.isAnswer = false;
      this.cell.question.question = this.cell.question.question.trim();
      this.cell.question.answer_id = this.cell.answer.id;
      this.cell.text = this.cell.question.question;
      PuzzleService.saveQuestion(this.cell.question)
        .then(response => {
          this.cell.question.id = response.id;
          this.cell.question_id = response.id;
          this.cell.updated = true;
        });
      Events.$emit(_PUZZLE_SET_QUESTION_, this.cell);
      this.close();
    },
    selectQuestion(event) {
      this.cell.question.id = event.id;
      this.cell.question.size = event.size;
      this.cell.question.size_id = event.size_id;
      this.cell.question.question = event.question;
    },
    close() {
      this.question = null;
      this.show = false;
    },
    getOptions() {
      if (!this.$store.state.puzzle.questionSizes) {
        this.getQuestionSizes();
      }
      this.getQuestionsByAnswer();
    },
    getQuestionsByAnswer() {
      if (this.cell.answer.id) {
        PuzzleService.getQuestionsByAnswerId(this.cell.answer.id)
          .then(response => {
            this.questionsAvailable = response;
          });
      }
    },
    toggleSetting(value, setting) {
      this.cell.settings[setting] = value;
    },
    limitQuestion(e) {
      const total = (this.cell.question.question) ? this.cell.question.question.length : 0;
      const size = (this.cell.question.size) ? this.cell.question.size.size : 20;
      if (total > size) {
        this.cell.question.question.slice(0, -1);
        if (e.keyCode >= 48 && e.keyCode <= 90) {
          e.preventDefault();
        }
      }
    },
    recalcQuestionLimit(event) {
      const { question } = this.cell;
      this.cell.question.size_id = event;
      [this.cell.question.size] = this.optionsSizes.filter(op => op.id === event);
      this.cell.question.question = (question.question) ? question.question.substring(0, this.cell.question.size.size) : null;
    },
    editQuestion() {
      this.setToggle({ type: 'puzzle_edit_question_modal', bool: true });
      Events.$emit(_PUZZLE_EDIT_QUESTION_OPTION_, this.question);
    },
  },
  destroyed() {
    this.question = null;
    Events.$off(_PUZZLE_QUESTION_OPTION_);
    Events.$off(_PUZZLE_CLOSE_ALL_MODAL_);
  },
  mounted() {
    this.getOptions();
    Events.$on(_PUZZLE_QUESTION_OPTION_, cell => {
      this.cell = cell;
      this.getQuestionsByAnswer();
      this.show = cell.active;
      this.up = ((cell.positiony * CELL_SIZE) - 320);
      this.left = ((cell.positionx * CELL_SIZE) + (CELL_SIZE / 2)) - 147;
    });
    Events.$on(_PUZZLE_CLOSE_ALL_MODAL_, () => {
      this.close();
    });
    Events.$on(_PUZZLE_UPDATE_QUESTION_OPTION_, () => {
      this.getQuestionsByAnswer();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  cursor: pointer;
}
.card-small {
  visibility: hidden;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1199;
  transition: all .5 ease-in;
  background: #d7d7d7;
  width: 300px;
  &:before {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #d7d7d7 transparent transparent transparent;
  }
  &.show {
    visibility: visible;
    transition: all .5 ease-in;
  }
  .bold {
    font-weight: bold;
  }
}
</style>
